



























import { mapGetters, mapActions } from 'vuex'
import BankNavbar from '@/components/BankNavbar.vue'
import UserModal from '@/components/UserModal.vue'

export default {
  name: 'BankUsers',
  components: {
    BankNavbar,
    UserModal
  },
  data () {
    return {
      userList: [],
    }
  },
  computed: {
    ...mapGetters([
      'sessionUser',
      'currentBank',
      'currentBankId',
    ])
  },
  methods: {
    ...mapActions([
      'getBankUsers'
    ]),

    async loadBankUsers () {
      const result = await this.getBankUsers()
      console.log('  loadBankUsers result', result)
      if (result.success) {
        this.userList = result.data
      }
    },

    newUser () {
      this.$refs.userModal.show({
        role: 'bank',
        bank_id: this.currentBankId
      })
    },

    editUser (user: User) {
      this.$refs.userModal.loadAndShow(user)
    }
  },
  async mounted () {
    console.log('BankUsers.mounted')
    console.log('  currentBank', this.currentBank)
    if (this.currentBank) {
      this.loadBankUsers()
    }
  }
}
